var cov_u3eqiq2yn = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tooltip/index.ts",
      hash = "1d70560379231a1d9633ffec5a54bc8f3c1bd865",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tooltip/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 43
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 39
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import create from './Container';
import * as events from './events';
var Tooltip = (cov_u3eqiq2yn.s[0]++, create(events));
cov_u3eqiq2yn.s[1]++;
Tooltip.displayName = 'ShineoutTooltip';
export default Tooltip;